import { NavLink } from "react-router";
import { cx } from "../../lib/cx";
import styles from "./SideNav.module.css";

export type SideNavItem = {
  label: string;
  href: string;
};

export type SideNavProps = {
  items: SideNavItem[];
  ariaLabel?: string;
};

export const SideNav = ({ items, ariaLabel = "Sub-navigation" }: SideNavProps) => (
  <nav aria-label={ariaLabel} className={styles.nav}>
    <ul className={styles.list}>
      {items.map((it) => (
        <li key={it.href}>
          <NavLink
            to={it.href}
            end
            className={({ isActive }: { isActive: boolean }) =>
              cx(styles.link, isActive && styles.active)
            }
          >
            {it.label}
          </NavLink>
        </li>
      ))}
    </ul>
  </nav>
);
